<template>
  <b-card title="درخواست‌های برداشت">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openDetails(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Owner)="data">
            <span>{{ (data.item.OwnerName || '') + ' ' + (data.item.OwnerFamily || '') }}</span>
          </template>

          <template #cell(Amount)="data">
            <span class="text-nowrap">{{ money(data.value) }}</span>
          </template>

          <template #cell(Sheba)="data">
            <span
              dir="ltr"
              class="text-nowrap"
            >{{ data.value || '—' }}</span>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">
              {{ statusText(data.value) }}
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            <span class="text-nowrap">{{ data.value | date('date-time') }}</span>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="cursor-pointer"
                @click="openDetails(data.item)"
              />
              <feather-icon
                v-if="data.item.Status === 1"
                icon="CheckIcon"
                size="16"
                class="ml-1 cursor-pointer text-success"
                @click="openPay(data.item)"
              />
              <feather-icon
                v-if="data.item.Status === 0 || data.item.Status === 1"
                icon="XIcon"
                size="16"
                class="ml-1 cursor-pointer text-danger"
                @click="openReject(data.item)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <!-- جزئیات -->
    <b-modal
      v-if="showDetails"
      v-model="showDetails"
      centered
      hide-footer
      title="جزئیات درخواست برداشت"
      :no-close-on-backdrop="true"
    >
      <div v-if="detail">
        <b-row>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">موبایل کاربر</small>
            <div class="font-weight-bold">{{ detail.Mobile }}</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">مبلغ</small>
            <div class="font-weight-bold">{{ money(detail.Amount) }} تومان</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">وضعیت</small>
            <div>
              <b-badge :variant="statusVariant(detail.Status)">{{ statusText(detail.Status) }}</b-badge>
            </div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">بانک</small>
            <div class="font-weight-bold">{{ detail.BankTitle || '—' }}</div>
          </b-col>
          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">شماره شبا</small>
            <div
              dir="ltr"
              class="font-weight-bold text-right"
            >{{ detail.Sheba || '—' }}</div>
          </b-col>
          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">صاحب حساب</small>
            <div class="font-weight-bold">{{ (detail.OwnerName || '') + ' ' + (detail.OwnerFamily || '') }}</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">تاریخ ثبت</small>
            <div class="font-weight-bold">{{ detail.CreatedAt | date('date-time') }}</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">تاریخ تأیید</small>
            <div class="font-weight-bold">
              {{ detail.VerifiedAt ? $options.filters.date(detail.VerifiedAt, 'date-time') : '—' }}
            </div>
          </b-col>
          <b-col
            v-if="detail.TrackingCode"
            md="6"
            class="mb-1"
          >
            <small class="text-muted">کد پیگیری</small>
            <div class="font-weight-bold">{{ detail.TrackingCode }}</div>
          </b-col>
          <b-col
            v-if="detail.PaidAt"
            md="6"
            class="mb-1"
          >
            <small class="text-muted">تاریخ تسویه</small>
            <div class="font-weight-bold">{{ detail.PaidAt | date('date-time') }}</div>
          </b-col>
          <b-col
            v-if="detail.RejectReason"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دلیل رد</small>
            <div class="text-danger">{{ detail.RejectReason }}</div>
          </b-col>
        </b-row>

        <hr v-if="detail.Status === 0 || detail.Status === 1">
        <div
          v-if="detail.Status === 0 || detail.Status === 1"
          class="d-flex justify-content-end"
        >
          <b-button
            variant="outline-danger"
            class="mr-1"
            @click="openReject(detail)"
          >رد</b-button>
          <b-button
            v-if="detail.Status === 1"
            variant="success"
            @click="openPay(detail)"
          >تسویه</b-button>
        </div>
      </div>
    </b-modal>

    <!-- تسویه -->
    <b-modal
      v-if="showPay"
      v-model="showPay"
      centered
      ok-title="ثبت تسویه"
      cancel-title="انصراف"
      ok-variant="success"
      cancel-variant="outline-secondary"
      title="تسویه‌ی برداشت"
      :no-close-on-backdrop="true"
      @ok.prevent="pay"
    >
      <p>مبلغ <b>{{ money(active.Amount) }}</b> تومان به شماره شبا
        <span dir="ltr">{{ active.Sheba }}</span>
        به‌صورت دستی واریز شده است؟</p>
      <b-form-group
        label="کد پیگیری (اختیاری)"
        label-for="TrackingCode"
      >
        <b-form-input
          v-model="trackingCode"
          autocomplete="off"
        />
      </b-form-group>
    </b-modal>

    <!-- رد -->
    <b-modal
      v-if="showReject"
      v-model="showReject"
      centered
      ok-title="ثبت رد"
      cancel-title="انصراف"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      title="رد درخواست برداشت"
      :no-close-on-backdrop="true"
      @ok.prevent="reject"
    >
      <p>مبلغ بلاک‌شده به کیف‌پول کاربر بازمی‌گردد.</p>
      <b-form-group
        label="دلیل رد (به کاربر نمایش داده می‌شود)"
        label-for="RejectReason"
      >
        <b-form-textarea
          v-model="rejectReason"
          rows="3"
          no-resize
        />
      </b-form-group>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'Withdrawal',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Mobile: null,
        Status: null,
        Page: 1,
        PerPage: 10,
      },
      statusOptions: [
        { text: 'در انتظار تأیید', value: 0 },
        { text: 'در انتظار تسویه', value: 1 },
        { text: 'تسویه‌شده', value: 2 },
        { text: 'ردشده', value: 3 },
        { text: 'لغوشده', value: 4 },
      ],
      items: [],
      showDetails: false,
      detail: null,
      showPay: false,
      showReject: false,
      active: {},
      trackingCode: null,
      rejectReason: null,
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Mobile', label: 'موبایل' },
        { key: 'Amount', label: 'مبلغ (تومان)' },
        { key: 'BankTitle', label: 'بانک' },
        { key: 'Owner', label: 'صاحب حساب' },
        { key: 'Sheba', label: 'شبا' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'CreatedAt', label: 'تاریخ' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    money(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR')
    },
    statusText(value) {
      return ['در انتظار تأیید', 'در انتظار تسویه', 'تسویه‌شده', 'ردشده', 'لغوشده'][value] || '—'
    },
    statusVariant(value) {
      return ['light-secondary', 'light-warning', 'light-success', 'light-danger', 'light-secondary'][value] || 'light-secondary'
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.withdrawal.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetails(item) {
      this.detail = item
      this.showDetails = true
    },
    openPay(item) {
      this.active = item
      this.trackingCode = null
      this.showPay = true
    },
    openReject(item) {
      this.active = item
      this.rejectReason = null
      this.showReject = true
    },
    pay() {
      this.$http.post(this.$api.withdrawal.pay, { Id: this.active.Id, TrackingCode: this.trackingCode })
        .then(() => {
          this.showPay = false
          this.showDetails = false
          this.update()
        })
    },
    reject() {
      this.$http.post(this.$api.withdrawal.reject, { Id: this.active.Id, RejectReason: this.rejectReason })
        .then(() => {
          this.showReject = false
          this.showDetails = false
          this.update()
        })
    },
  },
}
</script>
